<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  ref="master"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Tipo recomendación')"
                            :formItemConfig="fiOptions"
                            :decorator="['type_recommen', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                            :params="tipoRecomendacion">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha recomendación')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['fecha_recommen', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Observación')">
                  <a-textarea auto-size
                              v-decorator="['obs_recommen', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipoRecomendacion: {h_lookup_type: 'TYPE_MEDICAL_RECOMMEN', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'medical_recommen',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_medical_recommen'
            },
            columns: [
              {title: 'ID Recomendación', dataIndex: 'id_medical_recommen', sorter: true},
              {title: 'Tipo', dataIndex: 'destyperecommen', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha_recomendacion', sorter: true},
              {title: 'Observación', dataIndex: 'obs_recommen', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'type_recommen'},
            {name: 'fecha_recommen'},
            {name: 'obs_recommen'}
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/RecomendacionesMedicas.vue